import { query_product_out_record_list } from '@/api/mjstock-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstock/mjstock-productoutrecord1-config';

import { reactive } from 'vue';
import { get_is_active, getDate, getDateTime, toFixed0 } from '@/utils/function';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'select',
        name: 'out_type',
        label: '出库类型',
        labelKey: 'name',
        disabled: false,
        placeholder: '请选择out_type',
        mode: 'multiple',
        allowClear: true,
      },
      {
        type: 'input',
        name: 'code',
        label: '出库单编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写单据编号',
      },
      {
        type: 'remotemodal',
        name: 's_product_id',
        label: '存货名称',
        disabled: false,
        placeholder: '请选择存货名称',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstock-sproduct',
      },
      {
        type: 'remotemodal',
        name: 'order_used_record_id',
        label: '关联耗单',
        disabled: false,
        placeholder: '请选择关联耗单',
        datasourceType: 'remote',
        mode: 'default',
        init_model: { shop_id: current_shop?.id },
        field_status: { shop_id: current_shop ? 0 : 2 },
        labelKey: 'order_code',
        allowClear: true,
        modalType: 'mjstore-orderusedrecord',
      },
      {
        type: 'remotemodal',
        name: 'product_in_record_id',
        label: '关联入库单',
        disabled: false,
        placeholder: '请选择关联入库单',
        datasourceType: 'remote',
        init_model: { shop_id: current_shop?.id },
        field_status: { shop_id: current_shop ? 0 : 2 },
        mode: 'default',
        allowClear: true,
        modalType: 'mjstock-productinrecord',
      },
      {
        type: 'remotemodal',
        name: 'to_shop_id',
        label: '调拨去向',
        disabled: false,
        placeholder: '请选择调拨去向',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'input',
        name: 'transfer_code',
        label: '调拨编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写调拨编号',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '执行门店',
        disabled: !!current_shop,
        placeholder: '请选择执行门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'remoteselect',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      code: null,
      s_product_id: null,
      order_used_record_id: null,
      product_in_record_id: null,
      out_type: null,
      to_shop_id: null,
      transfer_code: null,
      shop_id: current_shop?.id,
      staff_id: null,
    }),
  };
  const search_options = {
    out_type: [
      { value: None, name: '全部' },
      { value: 1, name: '销售出库' },
      { value: 2, name: '盘亏出库' },
      { value: 3, name: '调拨出库' },
      { value: 4, name: '员工福利' },
      { value: 5, name: '客户试用' },
      { value: 6, name: '其他出库' },
    ],
    is_active: [
      { value: None, name: '全部' },
      { value: True, name: '可用' },
      { value: False, name: '作废' },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '产品出库记录管理',
    addModalTitle: '新建产品出库记录',
    updateTitle: '修改产品出库记录',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '出库编号',
      width: 180,
      dataIndex: 'code',
      fixed: 'left',
      checked: true,
    },
    {
      title: '关联耗单编号',
      width: 180,
      dataIndex: 'order_used_record__order_code',
      checked: true,
    },

    {
      title: '关联入库单编号',
      width: 190,
      dataIndex: 'product_in_record__code',
      checked: true,
    },
    {
      title: '出库类型',
      width: 110,
      dataIndex: 'out_type',
      checked: true,
      content: (record: any, text: any) => {
        let content = '';
        switch (text) {
          case 1:
            content = '销售出库';
            break;
          case 2:
            content = '盘亏出库';
            break;
          case 3:
            content = '调拨出库';
            break;
          case 4:
            content = '员工福利';
            break;
          case 5:
            content = '客户试用';
            break;
          case 6:
            content = '其他出库';
            break;
          default:
            content = '';
            break;
        }
        return content;
      },
      filterMultiple: true,
      filters: [
        { text: '全部', value: '' },
        { text: '销售出库', value: '1' },
        { text: '盘亏出库', value: '2' },
        { text: '调拨出库', value: '3' },
        { text: '员工福利', value: '4' },
        { text: '客户试用', value: '5' },
        { text: '其他出库', value: '6' },
      ],
    },
    {
      title: '存货编号',
      width: 110,
      dataIndex: 's_product__code',
      checked: true,
    },
    {
      title: '存货名称',
      width: 110,
      dataIndex: 's_product__name',
      checked: true,
    },
    {
      title: '存货规格',
      width: 80,
      dataIndex: 's_product__gg',
      checked: true,
    },
    {
      title: '存货单位',
      width: 80,
      dataIndex: 's_product__dw',
      checked: true,
    },
    {
      title: '存货数量',
      width: 80,
      dataIndex: 'remain_num',
      checked: true,
    },
    {
      title: '存货单价',
      width: 80,
      dataIndex: 'single_price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '存货金额',
      width: 80,
      dataIndex: 'price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '调拨去向',
      width: 110,
      dataIndex: 'to_shop__name',
      checked: true,
    },
    {
      title: '调拨编号',
      width: 110,
      dataIndex: 'transfer_code',
      checked: true,
    },
    {
      title: '出库数量',
      width: 80,
      dataIndex: 'out_num',
      checked: true,
    },
    {
      title: '出库日期',
      width: 110,
      dataIndex: 'out_datetime',
      checked: true,

      content: (record: any, text: any) => {
        return getDate(text);
      },
    },
    {
      title: '创建日期',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '执行门店',
      width: 80,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '执行人',
      width: 80,
      dataIndex: 'staff__name',
      checked: true,
    },
    {
      title: '单据状态',
      width: 110,
      dataIndex: 'is_active',
      checked: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '作废',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: true },
        { text: '作废', value: false },
      ],
      content: (record: any, text: any) => {
        return get_is_active(text);
      },
    },
    {
      title: '操作',
      width: 130,
      dataIndex: 'action',
      checked: true,
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push(
    {
      type: 'custom',
      slotName: 'out_type',
      field_1: '销售出库',
      field_2: '盘亏出库',
      field_3: '调拨出库',
      field_4: '员工福利',
      field_5: '客户试用',
      field_6: '其他出库',
    },
    { type: 'custom', slotName: 'is_active', field_true: '可用', field_false: '作废' },
  );

  // const route = useRoute();
  // const path_arr = route.path.split('/');
  // const out_type_str = path_arr[path_arr.length - 2];
  // let out_type = 0;
  // if(out_type_str=='xiaoshou'){
  //   out_type = 1;
  // }
  // if(out_type_str=='pankui'){
  //   out_type = 2;
  // }
  // if(out_type_str=='diaobo'){
  //   out_type = 3;
  // }
  // if(out_type_str=='yuangong'){
  //   out_type = 4;
  // }
  // if(out_type_str=='kehu'){
  //   out_type = 5;
  // }
  // if(out_type_str=='qita'){
  //   out_type = 6;
  // }
  // search_config.model.out_type = out_type;
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_product_out_record_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
